module.exports = "https://s91588.cdn.ngenix.net/news-frontend/_next/static/images/Qr-7117cdfbfbaae660b49e23f2eed998ac.svg";